export enum McpAccessLevel {
  Disabled = 'Disabled',
  ReadOnly = 'ReadOnly',
  Full = 'Full'
}

export const MCP_ACCESS_LEVEL_ORDER: McpAccessLevel[] = [McpAccessLevel.Disabled, McpAccessLevel.ReadOnly, McpAccessLevel.Full];

export function mcpAccessLevelFromFlags(readAccess: boolean, fullAccess: boolean): McpAccessLevel {
  if (fullAccess) return McpAccessLevel.Full;
  if (readAccess) return McpAccessLevel.ReadOnly;

  return McpAccessLevel.Disabled;
}
